export default __webpack_public_path__ + "static/media/device-management-orange.d28dd090.svg";